import { EstatutoStatus } from '../../../hooks/useEstatuto';

export const STATUS_COLORS: Record<EstatutoStatus, { bg: string; border: string; chip: string }> = {
  criado: {
    bg: '#F8FAFC',
    border: '#E2E8F0',
    chip: '#94A3B8',
  },
  aguardando_preenchimento: {
    bg: '#EFF6FF',
    border: '#BFDBFE',
    chip: '#3B82F6',
  },
  aguardando_validacao: {
    bg: '#FEF3C7',
    border: '#FDE68A',
    chip: '#F59E0B',
  },
  aguardando_validacao_cliente: {
    bg: '#FEF3C7',
    border: '#FDE68A',
    chip: '#F59E0B',
  },
  analise_cliente_concluida: {
    bg: '#FFF7ED',
    border: '#FED7AA',
    chip: '#EA580C',
  },
  enviar_assinatura: {
    bg: '#EDE9FE',
    border: '#DDD6FE',
    chip: '#7C3AED',
  },
  em_acompanhamento: {
    bg: '#ECFEFF',
    border: '#A5F3FC',
    chip: '#0891B2',
  },
  em_abertura_cnpj: {
    bg: '#ECFEFF',
    border: '#A5F3FC',
    chip: '#0891B2',
  },
  assinado_finalizado: {
    bg: '#DCFCE7',
    border: '#BBF7D0',
    chip: '#16A34A',
  },
};

/**
 * Paleta aplicada às colunas do board na ordem em que vêm do kanban.
 * Usa modulo pra não quebrar caso o número de colunas mude no backend.
 */
export const COLUMN_PALETTE: { bg: string; border: string; chip: string }[] = [
  STATUS_COLORS.criado,
  STATUS_COLORS.aguardando_preenchimento,
  STATUS_COLORS.aguardando_validacao,
  STATUS_COLORS.aguardando_validacao_cliente,
  STATUS_COLORS.analise_cliente_concluida,
  STATUS_COLORS.enviar_assinatura,
  STATUS_COLORS.em_acompanhamento,
  STATUS_COLORS.em_abertura_cnpj,
  STATUS_COLORS.assinado_finalizado,
];

export const STATUS_SHORT_LABEL: Record<EstatutoStatus, string> = {
  criado: 'Criado',
  aguardando_preenchimento: 'Aguardando preenchimento',
  aguardando_validacao: 'Aguardando validação',
  aguardando_validacao_cliente: 'Aguardando validação do cliente',
  analise_cliente_concluida: 'Análise do cliente concluída',
  enviar_assinatura: 'Enviar para assinatura',
  em_acompanhamento: 'Acompanhamento do processo',
  em_abertura_cnpj: 'Abertura do CNPJ',
  assinado_finalizado: 'Assinado / Finalizado',
};

/**
 * Copia uma string para o clipboard usando navigator.clipboard com fallback
 * para textarea pra browsers/contextos sem permissão.
 */
export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-9999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(textArea);
    return ok;
  } catch {
    return false;
  }
};

export const formatDateBR = (iso: string | null): string => {
  if (!iso) return '—';
  const soData = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  if (soData) return `${soData[3]}/${soData[2]}/${soData[1]}`;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};

export const formatDateTimeBR = (iso: string | null): string => {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};
